console.log('🔥 variant-option-prices loaded');
 
document.addEventListener('DOMContentLoaded', () => {
 
  /* ===============================
     1️⃣ Product variants
  =============================== */
  const variantsJSON = document.getElementById('ProductVariantsJSON');
  if (!variantsJSON) return;
 
  const variants = JSON.parse(variantsJSON.textContent);
 
  const moneyFormat = window.moneyFormat || '{{amount}}';
 
  /* ===============================
     2️⃣ Helpers
  =============================== */
  const normalize = str => str ? str.replace(/\s+/g, ' ').trim() : '';
 
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const amount = cents / 100;
 
    const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
      const fixed = number.toFixed(precision);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
 
    return format
      .replace('{{amount}}', formatWithDelimiters(amount, 2))
      .replace('{{amount_with_comma_separator}}', formatWithDelimiters(amount, 2, '.', ','))
      .replace('{{amount_no_decimals}}', formatWithDelimiters(amount, 0))
      .replace('{{amount_no_decimals_with_comma_separator}}', formatWithDelimiters(amount, 0, '.', ','));
  }
 
  /* ===============================
     3️⃣ Selected options
  =============================== */
  function getSelectedOptions() {
    const selected = [];
    document.querySelectorAll('variant-selects fieldset').forEach(fieldset => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      selected.push(checked ? normalize(checked.value) : '');
    });
    return selected;
  }
 
  /* ===============================
     4️⃣ Update prices
  =============================== */
  function updateOptionPrices() {
    const selectedOptions = getSelectedOptions();
 
    document.querySelectorAll('.variant-label').forEach(label => {
      const position = parseInt(label.dataset.optionPosition, 10) - 1;
      const value = normalize(label.dataset.optionValue);
 
      const testOptions = [...selectedOptions];
      testOptions[position] = value;
 
      const matchedVariant = variants.find(variant =>
        variant.options.every((opt, i) => normalize(opt) === testOptions[i])
      );
 
      const priceEl = label.querySelector('.variant-price');
      if (!priceEl) return;
 
      priceEl.textContent = matchedVariant
        ? formatMoney(matchedVariant.price, moneyFormat)
        : '—';
    });
  }
 
  /* ===============================
     5️⃣ Init
  =============================== */
  updateOptionPrices();
 
  /* ===============================
     6️⃣ Dawn variant change hook
  =============================== */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, updateOptionPrices);
  }
 
  /* ===============================
     7️⃣ Radio change fallback
  =============================== */
  document.querySelectorAll('input[type="radio"]').forEach(input => {
    input.addEventListener('change', updateOptionPrices);
  });
 
});
 
 